module.exports = __webpack_public_path__ + "static/media/arrow-from-bottom.5cf76b6c.svg";